<template>
    <div>
        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            width="65%"
            :close-on-click-escape="false"
            :close-on-click-modal="false"
             @closed="onHidden"
            :before-close="onHidden"
            custom-class="loadingDivCreate"
            center>
            <div v-if="showResult">
                <h1 class="text-md-center" >ยืนยันการ Create Shipment</h1>
                <h1 class="text-md-center">รายการ</h1>
                <hr>
                <div v-if="detail.length>0" >
                    <div v-for="(item,index) in detail" :key="index" >
                        <h1 class="text-md-center">ร้าน : {{item.shopName}} จำนวนจำนวนออเดอร์ : {{item.orderNumbers.length}}</h1>
                    </div>
                </div>
                <h1 v-else class="text-md-center">ไม่มีรายการ</h1>
            </div>
            <div v-else>
                <h1 class="text-md-center" >Result Create Shipment</h1>
                <h1 class="text-md-center">รายการร้าน</h1>
                <hr>
                <div v-for="(item,index) in resultCreateShipment" :key="index" >
                    <h1 class="text-md-center">ร้าน : {{item.shopName}} จำนวนจำนวนออเดอร์ : {{item.result.length}}</h1>
                    <el-table
                    :data="item.result"
                    border
                    style="width: 100%">
                        <el-table-column
                        prop="orderNumber"
                        label="orderNumber"
                        width="100">
                        </el-table-column>
                        <el-table-column
                        prop="trackingNumber"
                        label="trackingNumber"
                        width="120">
                        </el-table-column>
                        <el-table-column
                        prop="courierProviderName"
                        label="Courier"
                        width="100"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="errorCode"
                        label="errorCode"
                        width="80">
                        </el-table-column>
                        <el-table-column
                        prop="errorMessage"
                        label="errorMessage">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
             <span v-if="showReSultIsTrueAndDetailEmpty" slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">ปิด</el-button>
             </span>
             <span v-else slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">ยกเลิก</el-button>
                <el-button type="primary" @click="createShipment" v-if="showResult">ยืนยัน</el-button>
            </span>
            </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'CreateShipment',
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
        CrateShipmentDetail: {
            type: Array,
            default: null
        }

    },
    data () {
        return {
            dialogVisible: false,
            detail: [],
            result: {},
            resultCreateShipment: [],
            showResult: true
        }
    },
    computed: {
        showReSultIsTrueAndDetailEmpty () {
            return this.showResult && this.detail.length <= 0
        }
    },
    watch: {
        dialogShow (val) {
            if (val) {
                // init data agian
                this.dialogVisible = true
            }
        },
        CrateShipmentDetail (val) {
            if (val) {
                this.detail = val
                console.log(val)
            }
        }
    },
    methods: {
        onHidden (done) {
            this.showResult = true
            this.result = {}
            this.$emit('closeModal')
            if (done !== undefined) {
                done()
            }
        },
        async createShipment () {
            let loadingAddUser = this.$loading({
                target: '.loadingDivCreate',
                text: 'กำลังบันทึก...'
            })
            let result = []
            for (const item of this.detail) {
                // console.log(item)
                try {
                    let param = {
                        order_numbers: item.orderNumbers,
                        shop_id: item.shopId,
                        status: 3,
                        adminEmail: this.$store.get('user/objUser').email
                    }
                    let res = await fgApi.order.createShipment(param)
                    console.log(res)
                    const resultFilterJnTFail = res.result.filter(e => {
                        return e.courierProviderName === 'J&T' && e.errorCode === 'S10'
                    })
                    console.log('result filter', resultFilterJnTFail)
                    let newResult = []
                    if (resultFilterJnTFail.length > 0) {
                        const orderNumber = resultFilterJnTFail.map(e => e.orderNumber)
                        console.log('map order Number', orderNumber)
                        let paramUpdate = {
                            orderNumbers: orderNumber,
                            shopId: item.shopId,
                            status: 3,
                            adminEmail: this.$store.get('user/objUser').email
                        }
                        console.log('update', paramUpdate)

                        let resUpdate = await fgApi.order.updateShipment(paramUpdate)
                        newResult = res.result.filter(e => {
                            const isOrder = orderNumber.includes(e.orderNumber)
                            if (!isOrder) {
                                return e
                            }
                        })
                        newResult = [...newResult, ...resUpdate.result]
                        console.log(newResult, res.result)
                    } else {
                        newResult = res.result
                    }
                    if (res.success) {
                        try {
                            await fgApi.order.updateDeliveryCost(param)
                        } catch (error) {
                            console.log(error)
                        }
                        result.push({
                            shopName: item.shopName,
                            result: newResult
                        })
                        this.showResult = false
                        this.resultCreateShipment = result
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                } catch (error) {
                    console.log(error)
                }

                console.log(result)
            }
            loadingAddUser.close()
        }

    }
}
</script>

<style lang="scss" scoped>

</style>
